import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { OrgRecord } from "@/shared/domain/orgs/OrgRecord";

export const searchOrgsQueryKey = (search: string) => [
  "orgs",
  "search",
  search,
];

/**
 * Search orgs by name or ID. Requires admin privileges.
 * Only fires when the search string is at least 2 characters.
 */
export function useSearchOrgs(search: string) {
  const { orgService } = useDomainServices();
  const trimmed = search.trim();

  return useQuery<OrgRecord[]>({
    queryKey: searchOrgsQueryKey(trimmed),
    queryFn: ({ signal }) =>
      orgService.searchOrgs(trimmed, { abortSignal: signal }),
    enabled: trimmed.length >= 2,
    staleTime: 30_000,
  });
}
